module.exports = __webpack_public_path__ + "static/omodele-02e304a964a304aff0a566add76ea175.png";